import { requestGet } from '@/common/request';

export interface getInventoryStatusParams {
  activityId: string;
}

export interface getInventoryStatusRes {
  ret: string;
  msg: string;
  data: {
    isShow: boolean;
    hasThresholdRule: boolean;
    needReceiveNum: number;
    needDeleteNum: number;
    isRuleChange: boolean;
    needConfirmInveRule: number;
  };
}

//品类盘货 - 品类盘货状态栏信息展示
export async function getInventoryStatus(params: getInventoryStatusParams): Promise<getInventoryStatusRes> {
  return await requestGet('/goodsPool/getInventoryStatus', params);
}
